// extracted by mini-css-extract-plugin
export default {"scrollable-content":"ViewBankDetails_scrollable-content__zr2TS","card":"ViewBankDetails_card__K9fVt","ant-card-head-title":"ViewBankDetails_ant-card-head-title__ISTrw"};